window.dataLayer = window.dataLayer || [];
function gtag() { window.dataLayer.push(arguments); }

const convertConsent = (flag) => flag === "yes" ? 'granted' : 'denied';

window.recordAnalyticsEvent = function(data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}

function recordForm(formData) {
  // Only interesting in Newsletter form
  if (!isFormNewsletterForm(formData)) return;

  let email = null;
  for (const item of formData.element.elements) {
    if (item.name.toLowerCase() === 'contact[email]') {
      email = item.value;
      break;
    }
  }

  var data = {
    event: 'newsletter_signup',
    user_data: {
      email: email
    }
  }

  window.recordAnalyticsEvent(data);
}

function isFormNewsletterForm(formData) {
  for (const item of formData.element.elements) {
    if (item.name.toLowerCase() === 'contact[tags]') {
      if (item.value.toLowerCase() === 'newsletter') return true;
    }
  }
  
  return false;
}

function consentDefaultValues() {
  gtag('consent', 'default', {
    'ad_personalization': 'denied',
    'ad_storage': 'denied',
    'ad_user_data': 'denied',
    'analytics_storage': 'denied',
    'functionality_storage': 'denied',
    'personalization_storage': 'denied',
    'security_storage': 'granted',
    'wait_for_update': 500,
  });
}

function consentDynamicValues() {
  let consent = window.Shopify.customerPrivacy.currentVisitorConsent();
  gtag('consent', 'default', {
    'ad_personalization': convertConsent(consent.marketing),
    'ad_storage': convertConsent(consent.marketing),
    'ad_user_data': convertConsent(consent.marketing),
    'analytics_storage': convertConsent(consent.analytics),
    'functionality_storage': convertConsent(consent.preferences),
    'personalization_storage': convertConsent(consent.preferences),
    'security_storage': 'granted',
    'wait_for_update': 500
  });
}

if (typeof window.Shopify === 'undefined') {
  console.log("[CONSENT] Shopify doesn't exist, returning default values");
  consentDefaultValues();
} else if (!window.Shopify.customerPrivacy) {
  console.log("[CONSENT] Shopify Customer Privacy doesn't exist, instancing");
  window.Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ],
    error => {
      if (error) {
        // Rescue error
        console.log("[CONSENT] Error instancing, returning default values", error);
        consentDefaultValues();
      }
      // The API has loaded and ready to use!
      console.log("[CONSENT] Returning Shopify current consent values");
      consentDynamicValues();
    },
  );
} else {
  consentDynamicValues();
}

window.addEventListener("message", function(event) {
  if (event.data?.type === "FORM_SUBMITTED") {
    recordForm(event.data.payload);
  }
});